export default {
  table: {
    width: "100%",
    border: "1px solid",
    borderColor: "greyscale.400",
    borderCollapse: "separate",
    borderSpacing: 0,
    borderRadius: "3px",
    borderLeft: 0,
    color: "greyscale.700",

    th: {
      fontWeight: "semibold",
      backgroundColor: "greyscale.200",
    },
    td: {
      borderTop: "1px solid",
      borderColor: "greyscale.400",
    },
    "th, td": {
      textAlign: "left",
      borderLeft: "1px solid",
      borderBottom: "1px solid",
      borderColor: "greyscale.400",
      padding: 4,
    },
    tr: {
      "&:first-of-type": {
        "th, td": {
          paddingTop: 2,
          paddingBottom: 2,

          "&:first-of-type": {
            borderTopLeftRadius: "3px",
          },

          "&:last-child": {
            borderTopRightRadius: "3px",
          },
        },
      },
      "&:last-child": {
        "th, td": {
          borderBottom: 0,

          "&:first-of-type": {
            borderBottomLeftRadius: "3px",
          },
        },
      },
    },
    caption: {
      marginBottom: "8px",
    },
    a: {
      color: "primary.500",
      textDecoration: "underline",
    },
  },
};
